import { MOOD, GENRE, BRAND, PAGE_TYPE, PODCAST_GENRE } from 'globalConst/const';
import { Image, Refs, UniversalCollectionItem, UniversalConfig, UniversalImage, UniversalRef } from 'api/interfaces';
import CollectionItem from './CollectionItem';

export interface UniversalTag extends UniversalCollectionItem {
  shortTitle: string;
  images: Array<UniversalImage>;
  config: Array<UniversalConfig>;
  labels: string[];
  refs: Array<UniversalRef>;
}

/**
 * @class
 * A representation of a Tag
 *
 * @param {object} tag - tag model
 */

export default class Tag extends CollectionItem {
  labels: string[];

  overviewSlug?: string;
  refs: Refs[];
  pageLink?: string;
  brandColor: string;

  image: Image;
  headerImage: Image;

  constructor(item: UniversalCollectionItem) {
    super(item);
    if (!item) {
      return null;
    }

    const tag = <UniversalTag>item;

    this.labels = tag.labels;

    if (tag.images && Array.isArray(tag.images)) {
      tag.images.forEach(({ imageType, uri, title }) => {
        switch (imageType) {
          case 'image':
            this.image = {
              url: uri,
              altText: title,
            };
            break;
          case 'header':
            this.headerImage = {
              url: uri,
              altText: title,
            };
            break;
          default:
            break;
        }
      });
    }

    if (!this.headerImage && this.image) {
      this.headerImage = this.image;
    }

    if (Array.isArray(tag.refs)) {
      this.overviewSlug = (tag.refs.find(({ targetType }) => targetType === 'overviewCollection') || {}).uri;
      this.refs = tag.refs
        // Only use Components which are prepared to use graphQL
        .filter(({ targetType }) => ['tagCollection', 'podcastCollection', 'stationCollection'].includes(targetType))
        .map(({ id, targetType, uri }) => ({
          uuid: id,
          contentTypeId: targetType,
          slug: uri,
        }));
    }

    switch (this.type) {
      case MOOD:
        this.pageLink = this.slug && PAGE_TYPE.MOODS.replace(':slug', this.slug);
        break;
      case GENRE: {
        this.pageLink = this.slug && PAGE_TYPE.GENRE.replace(':slug', this.slug);
        break;
      }
      case PODCAST_GENRE: {
        this.pageLink = this.slug && PAGE_TYPE.PODCAST_GENRE.replace(':slug', this.slug);
        break;
      }
      case BRAND: {
        const slug = this.overviewSlug;
        this.pageLink = slug && PAGE_TYPE.BRAND.replace(':slug', slug);
        break;
      }
      default:
        break;
    }

    if (Array.isArray(tag.config)) {
      this.brandColor = tag.config.reduce((acc, { entries }) => {
        const brandColor = entries.find(({ key }) => key === 'BackgroundColor');
        return brandColor ? brandColor.value : acc;
      }, '#000');
    }

    // Make this class read-only
    Object.freeze(this);
  }
}
